import type { StrictTypedTypePolicies } from "graphql-api/apollo-helpers";

export const typePolicies: StrictTypedTypePolicies = {
  MadeDesignProject: {
    keyFields: ["id"],
    fields: {
      products: {
        merge: (_existing: any, incoming: any) => incoming
      },
      backPlacement: {
        merge: (_existing: any, incoming: any) => incoming
      },
      frontPlacement: {
        merge: (_existing: any, incoming: any) => incoming
      }
    }
  },
  DtfArtwork: {
    keyFields: ["id"]
  },
  MadeDesignProjectProduct: {
    keyFields: ["catalogNumber", "compositionId"]
  },
  MadeDesignProjectProductVariantQuantity: {
    keyFields: ["variantId"]
  },
  MadeDesignProjectPlacement: {
    keyFields: ["id"],
    fields: {
      dtfArtwork: {
        merge: (_existing: any, incoming: any) => incoming
      }
    }
  },
  Order: {
    keyFields: ["id"]
  },
  Query: {
    fields: {
      currentOrder: {
        merge: (_existing: any, incoming: any) => incoming
      },
      madeDesignProject: {
        merge: (_existing: any, incoming: any) => incoming
      }
    }
  }
};
